<template>

    <div class="main">
        <img alt="Vue logo" class="image-holder" src="../assets/forside-logo.png" style="" />
        <div class="wrapper">
            <Step2></Step2>
        </div>

    </div>

</template>

<script>
    import Step2 from "../components/Step2.vue";
    export default {
        name: "Home",
        components: {
            Step2

        },
        data() {
            return {
                submitting:false,
                parcel: {
                    parcelnumber: "",
                    zipcode: "",
                    mail: "",
                    location: "",
                    extra: "",
                    acceptSmsAdvise: false,
                    acceptConditions:false,
                }
            };
        },
        methods:{
            submit(){
                this.$refs.parcelForm.submit();
            }
        }
    };
</script>

<style lang="scss" scoped>
    #app {
        font-family: "NewsonGLS-Regular", Verdana, sans-serif;
    }
    .wrapper{

        border: 1px solid #FFFFFF;
        box-sizing: border-box;
        border-radius: 0px 0px 10px 10px;
        @media screen and(min-width:800px) {
            width: 100%;
            display: flex;
            justify-content: center;
            border: 1px solid #d6d6d6;
            padding: 38px;
            box-shadow: #d6d6d6 0px 0px 30px
        }
    }
    .main {
        max-width: 800px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        .image-holder2{
            border-radius: 10px 10px 0px 0px;
            width:800px;
            @media screen and (max-width: 800px) {
                width:100%;
            }
        }

        .logo {
            max-width: 200px;

            display: flex;
            flex-direction: column;
            @media screen and(max-width: 800px){
                flex-direction: row;
            }
            button{
                align-self: center;
                margin-top:auto;
                @media screen and(max-width: 800px){
                    display:none;
                }
            }

            img {
                width: 100%;
            }
            @media screen and (max-width: 1080px) {
                max-width: 600/19.2 * 1vw;
            }
            @media screen and (max-width: 800px) {
                display: flex;
                justify-content: center;
                width: 100%;
                max-width: 100%;
                max-width: 100%;
                img {
                    width: 50%;
                }
            }
        }
    }
</style>